<template>
  <b-modal
    id="diver-traveler-modal"
    title="Diver Traveler Referral Program"
    header-bg-variant="dark"
    header-text-variant="white"
    body-bg-variant="light"
    size="xl"
    scrollable
    v-model="isShown"
  >
    <h6 class="font-weight-bold">Diver Traveler Referral Program Connects Members with Job Opportunities</h6>
    <p>
      The Brotherhood's construction divers now have opportunities for more work, thanks to the launch of the UBC's
      International Diver Traveler Referral Program (TRP). Certified divers who are willing to travel should register
      with this system at
      <a href="https://trp.carpenters.org" target="_blank" rel="noopener">UBC Diver Traveler Referral Program</a>.
    </p>
    <p>
      The web-based portal provides an easy way for divers to make their availability and skill certifications
      known— and for distant UBC locals to quickly locate and deploy divers to fit the needs of specific work sites.
    </p>
    <p>
      "Traditionally, our divers have always been willing to travel," said UBC Representative Bob Laufenberg. "For
      example, in colder months, divers from the north will help on jobs that come up in the south. This portal makes
      it easier for both the divers and the Union to place them on jobs. The system helps our members and our industry
      partners to efficiently find each other — and get the job done at the highest level," Laufenberg said.
    </p>
    <p>
      The referral program uses the Carpenter International Training Fund's (CITF)
      <a href="https://www.carpenters.org/train-program/" target="_blank" rel="noopener">TRAIN system</a>, where
      divers list their skills and specialties as well as their available travel schedules and desired locations.
    </p>
    <p>
      In order to register, divers must have all of their diver certifications and qualifications entered into the
      UBC TRAIN System. This is done at the diver's home regional training center. Divers must also be willing to be
      drug tested and have a criminal background check. UBC local representatives then log into the system to find
      the divers that suit particular assignments in their areas.
    </p>
    <h6 class="font-weight-bold mt-3">Important things to remember:</h6>
    <ul>
      <li>This online registration system is the only way to get into the UBC Diver TRP.</li>
      <li>You must have all your certifications and qualifications entered into the TRAIN system.</li>
      <li>No one can predict when or if you will get contacted to travel. There is no "average wait" or "probably by" date.</li>
      <li>Certified divers who are willing to travel should register with this system and have their information available to dispatchers across the United States.</li>
    </ul>
    <template #modal-footer>
      <b-button variant="secondary" @click="isShown = false">Cancel</b-button>
      <b-button variant="primary" href="https://trp.carpenters.org" target="_blank" rel="noopener" @click="isShown = false">Get Started Now</b-button>
    </template>
  </b-modal>
</template>
<script>
import { Vue, Component, Prop } from 'vue-property-decorator';

@Component
export default class DiverTravelerModal extends Vue {
  @Prop({ type: Boolean, default: false }) value;

  get isShown() {
    return this.value;
  }

  set isShown(val) {
    this.$emit('input', val);
  }
}
</script>
